import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { addDocToFirestore, filterProfilePicture } from "../../../helper";
import FiverrCard from "../../studentsJourneyAdvanceFilter/FiverrCard";
import Teacher from "../../../assets/images/avatar.jpg";
import TeacherDetailPopup from "../../../components/teacher-detail-popup";
import styles from "./style.module.css";
import { Modal } from "antd";
import Chat from "../../../components/chat/chat";
import CreateOfferCard from "../../../components/createOfferCard/CreateOfferCard";
import { MdFavoriteBorder } from "react-icons/md";
import NoRecordsFound from "../../../components/no-records-found";
import {
  DEMO_TYPE,
  filters,
  OFFER_TYPE_MESSAGES,
  offerStatuses,
} from "../../../constants";
import api, { baseUrl } from "../../../services/api";

const INITIAL_OFFER_DATA = {
  offerType: DEMO_TYPE,
};
const FavouriteTeachers = () => {
  const user = useSelector((state) => state.auth.user);
  const [favourites, setFavourites] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [teacherDetail, setTeacherDetail] = useState(false);
  const [multiFilter, setMultiFilter] = useState([
    {
      id: 1,
      name: "Matric",
    },
    {
      id: 2,
      name: "Intermediate",
    },
    {
      id: 3,
      name: "Graduate",
    },
    {
      id: 4,
      name: "Post-Graduate",
    },
    {
      id: 5,
      name: "Doctrate",
    },
  ]);
  const [openMessageModal, setOpenMessageModal] = useState({
    itemDetail: "",
    open: false,
  });
  const [openScheduleDemoModal, setOpenScheduleDemoModal] = useState({
    itemDetail: "",
    open: false,
  });
  const [offerDetail, setOfferDetail] = useState({
    ...INITIAL_OFFER_DATA,
  });
  const [selectedItem, setSelectedItem] = useState({
    itemDetail: "",
    open: false,
  });
  const videoRef = useRef(null);

  const loggedInUser = useSelector((state) => state.auth.user);

  const fetchFavouriteStudents = async () => {
    setIsLoading(true);
    try {
      const res = await api.get(`/students/${user?.id}/teachers/favourites`);
      setFavourites(res?.data?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user?.id) fetchFavouriteStudents();
  }, [user]);

  const filterIntroVideo = (list) => {
    if (list?.length) {
      let introVideo = list?.find((item) => item?.type === "introVideos");
      if (introVideo) {
        return `${baseUrl}${introVideo?.url}`;
      }
    }
  };

  const sendOffer = async (offerData) => {
    try {
       const receiverProfileUrl = openScheduleDemoModal?.itemDetail?.teacherMedia?.find(
         (x) => x?.type === "profilePicture"
       )?.url;
      let messageBody = {
        text: OFFER_TYPE_MESSAGES.DEMO,
        sender_uuid: loggedInUser?.uuid,
        senderName: loggedInUser?.fullName,
        senderRole: loggedInUser?.role || "",
        receiver_uuid: openScheduleDemoModal?.itemDetail?.uuid,
        receiverId: openScheduleDemoModal?.itemDetail?.id,
        receiverName: openScheduleDemoModal?.itemDetail?.fullName,
        timestamp: new Date().toISOString(),
        seen: false,
        offerDetail: { ...offerData, offerStatus: offerStatuses.PENDING },
      };
      await addDocToFirestore(
        loggedInUser?.uuid,
        openScheduleDemoModal?.itemDetail?.uuid,
        messageBody
      );
      const localProfilePic = localStorage.getItem("profilePicture");
      const senderProfileUrl = localProfilePic || loggedInUser?.profilePicture;
      await addDocToFirestore(loggedInUser?.uuid, openScheduleDemoModal?.itemDetail?.uuid, messageBody, senderProfileUrl, receiverProfileUrl);
      setOpenScheduleDemoModal(false, {});
    } catch (error) {}
  };

  function filterExpertiseSubject(subjects) {
    const expertSubjects = subjects.filter((subj) => subj.expert);
    const selectedSubjects =
      expertSubjects.length > 0 ? expertSubjects : subjects.slice(0, 3);
    return selectedSubjects.map((subj) => subj.courseSubjectName).join(", ");
  }

  // console.log('openScheduleDemoModal?.itemDetail.id',openScheduleDemoModal)
  const handleCloseVideoModal = () => {
    // Pause the video when the modal is closed
    if (videoRef.current) {
      videoRef.current.pause();
    }

    // Close the modal
    handleVideoModal(false, "");
  };

  const handleVideoModal = (status, item) => {
    setSelectedItem({
      open: status,
      itemDetail: item,
    });
  };

  return (
    <div>
      {/* video modal */}
      {
        <Modal
          maskClosable={false}
          width={700}
          footer={null}
          title=""
          open={selectedItem?.open}
          onOk={() => handleCloseVideoModal()}
          onCancel={() => handleCloseVideoModal()}
        >
          <div className="m-4">
            <video
              key={selectedItem?.itemDetail}
              ref={videoRef}
              autoPlay
              controls
              controlsList="nodownload"
              width={600}
              height={400}
            >
              <source src={selectedItem?.itemDetail} type="video/mp4" />
            </video>
          </div>
        </Modal>
      }
      <h1 className="pageTitle">Favourite Teachers</h1>
      {/* <hr /> */}
      <div className="row">
        {isLoading
          ? [1, 2, 3, 4].map((_, index) => (
              <div key={index} className="col-6 col-md-4 col-lg-3 mb-4">
                <div className="placeholder-glow">
                  <div className="card h-100">
                    <div
                      className="placeholder card-img-top"
                      style={{ height: "200px" }}
                    ></div>
                    <div className="card-body">
                      <p className="placeholder col-6"></p>
                      <p className="placeholder col-4"></p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          : favourites.map((x) => {
              const introVideo = filterIntroVideo(x?.teacher?.teacherMedia);
              const profileImage =
                filterProfilePicture(x?.teacher?.teacherMedia) || Teacher;
              // Get qualification list from multiFilter
              const coverImage = filterProfilePicture(x?.teacher?.teacherMedia, "coverImage") || "";
              const qualificationList = multiFilter;

              // Find matching qualification name
              const qualificationId = x?.teacher?.qualificationLevelId;

              let qualificationName = "";

              if (qualificationList.length > 0) {
                qualificationName = qualificationList.find(
                  (qual) => qual.id === qualificationId
                )?.name;
              }

              return (
                <div
                  key={x?.teacher?.id}
                  className="col-6 col-md-4 col-lg-3 mb-4"
                >
                  <FiverrCard
                    // image={
                    //   filterProfilePicture(x?.teacher?.teacherMedia) || Teacher
                    // }
                    videoPreview={introVideo} // <-- shows <video> instead of image
                    image={profileImage} // fallback
                    coverImage={coverImage}
                    videoThumbnail={filterProfilePicture(
                      x?.teacher?.teacherMedia
                    )}
                    onPlayVideo={() => handleVideoModal(true, introVideo)}
                    title={x?.teacher?.fullName}
                    description={filterExpertiseSubject(x?.teacher?.courses)}
                    intro={x?.teacher?.intro}
                    rating={Math.round(parseInt(x?.teacher?.rating))}
                    reviewsCount={x?.teacher?.ratingCount || 0}
                    price={x?.teacher?.price || "-"}
                    onViewDetails={() => setTeacherDetail(x?.teacher || false)}
                    onSendMessage={() =>
                      setOpenMessageModal({
                        itemDetail: x?.teacher,
                        open: true,
                      })
                    }
                    setProfileImage={setProfileImage}
                    onScheduleDemo={() =>
                      setOpenScheduleDemoModal({
                        itemDetail: x?.teacher,
                        open: true,
                      })
                    }
                    // handleShowReviews={() => handleShowReviews(item?.id)}
                    teacherId={x?.teacher?.id}
                    qualificationName={qualificationName}
                    isFavorite={true}
                    teacherUuid={x?.teacher?.uuid}
                  />
                </div>
              );
            })}

        {favourites.length === 0 && !isLoading && (
          <div className="notfound">
            <NoRecordsFound message="No favourites teachers found!" />
          </div>
        )}
        <TeacherDetailPopup
          visible={!!teacherDetail}
          onClose={() => setTeacherDetail(false)}
          teacherDetail={teacherDetail}
        />

        <Modal
          maskClosable={false}
          width={700}
          footer={null}
          closable
          title=""
          open={openMessageModal?.open}
          onOk={() => setOpenMessageModal({ itemDetail: "", open: false })}
          onCancel={() => {
            setOpenMessageModal({ itemDetail: "", open: false });
            setProfileImage(null);
          }}
        >
          <Chat
            profileImage={profileImage}
            receiver={openMessageModal?.itemDetail}
          />
        </Modal>

        <CreateOfferCard
          setOfferDetail={setOfferDetail}
          offerDetail={offerDetail}
          teacherId={openScheduleDemoModal?.itemDetail?.id}
          studentId={loggedInUser?.id}
          onSendOffer={sendOffer}
          handleOk={() => setOpenScheduleDemoModal(false, {})}
          handleCancel={() => setOpenScheduleDemoModal(false, {})}
          open={openScheduleDemoModal?.open}
        />
      </div>
    </div>
  );
};

export default FavouriteTeachers;
